define("settings/components/meta-ad-accounts-card/business-account-tab/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/constants/segment-events", "later/utils/expires-in-days", "later/utils/to-array", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _segmentEvents, _expiresInDays, _toArray, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/constants/segment-events",0,"later/utils/expires-in-days",0,"later/utils/to-array",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck }}
  <section class="tAC--mmaBusinessTab qa--mmaBusinessTab">
    {{#if this.metaAdUser}}
      <div class="tAC--mmaBusinessTab__headerRow">
        <div class="tAC--mmaBusinessTab__accountInfo">
          <span class="tAC--mmaBusinessTab__accountName qa--mmaBusinessTab__accountName">
            {{this.metaAdUser.metaAccountName}}
          </span>
          {{#if this.shouldShowExpiresIn}}
            <span
              class="tAC--mmaBusinessTab__expiresIn {{this.expiresInClass}} u--text--xs qa--mmaBusinessTab__expiresIn"
              data-test-id="mma-business-tab-expires-in"
            >
              {{t "account.social_accounts.expires_in.label"}}
              {{t "account.social_accounts.expires_in.value" days=this.expiresInDays}}
              <Shared::Ui::IconTooltip
                @icon="info"
                @side="top"
                @tooltip={{t "account.meta_marketing_api.business_account_tab.expires_in.tooltip"}}
                data-test-id="mma-business-tab-expires-in-tooltip"
              />
            </span>
          {{else}}
            <span
              class="tAC--mmaBusinessTab__expiresIn u--text--danger u--text--xs qa--mmaBusinessTab__expired"
              data-test-id="mma-business-tab-expired"
            >
              {{t "account.meta_marketing_api.business_account_tab.expires_in.expired"}}
            </span>
          {{/if}}
        </div>
        <div class="tAC--mmaBusinessTab__actions">
          <Shared::Ui::Button
            @onClick={{this.manageAdAccounts}}
            @size="small"
            @variant="outline"
            class="tAC--mmaBusinessTab__btn qa--mmaBusinessTab__editBtn"
          >
            {{svg-jar "edit" class="o--icon--xs tAC--mmaBusinessTab__btnIcon"}}
            {{t "account.meta_marketing_api.business_account_tab.edit_button"}}
          </Shared::Ui::Button>
          <Shared::Ui::Button
            @promise={{this.refresh}}
            @size="small"
            @variant="outline"
            class="tAC--mmaBusinessTab__btn qa--mmaBusinessTab__refreshBtn"
          >
            {{svg-jar "refresh" class="o--icon--xs tAC--mmaBusinessTab__btnIcon"}}
            {{t "account.meta_marketing_api.business_account_tab.refresh_button"}}
          </Shared::Ui::Button>
        </div>
      </div>
  
      <table class="tAC--mmaBusinessTab__table qa--mmaBusinessTab__table" {{did-insert this.onTableInserted}}>
        <thead>
          <tr>
            <th class="tAC--mmaBusinessTab__th tAC--mmaBusinessTab__th--name">
              <span class="tAC--mmaBusinessTab__thLabel">
                {{t "account.meta_marketing_api.business_account_tab.table.ad_account"}}
                <Shared::Ui::IconTooltip
                  @icon="info"
                  @side="top"
                  @tooltip={{t "account.meta_marketing_api.business_account_tab.table.ad_account_tooltip"}}
                  data-test-id="mma-business-tab-ad-account-tooltip"
                />
              </span>
            </th>
            <th class="tAC--mmaBusinessTab__th">
              {{t "account.meta_marketing_api.business_account_tab.table.access_groups"}}
            </th>
          </tr>
        </thead>
        <tbody>
          {{#each this.adAccounts as |adAccount|}}
            <tr class="tAC--mmaBusinessTab__tr qa--mmaBusinessTab__row" data-ad-account-id={{adAccount.id}}>
              <td class="tAC--mmaBusinessTab__td tAC--mmaBusinessTab__td--name qa--mmaBusinessTab__name">
                {{adAccount.name}}
              </td>
              <td class="tAC--mmaBusinessTab__td tAC--mmaBusinessTab__td--groups">
                <div class="tAC--mmaBusinessTab__badges">
                  {{#each (this.groupsFor adAccount) as |group|}}
                    <span class="tAC--mmaBusinessTab__badge qa--mmaBusinessTab__badge">{{group.name}}</span>
                  {{/each}}
                </div>
              </td>
            </tr>
          {{/each}}
        </tbody>
      </table>
  
      <Section
        @title={{t "account.meta_marketing_api.business_account_tab.remove_section.title"}}
        @titleStyles="u--text--danger"
        class="tAC--mmaBusinessTab__removeSection qa--mmaBusinessTab__removeSection"
        as |section|
      >
        <section.wrapper>
          <section.details
            @title={{t "account.meta_marketing_api.business_account_tab.remove_section.description"}}
            @titleStyles="u--text--danger u--text--md"
          />
          <Shared::Ui::Button
            @promise={{this.metaMarketingApiAuth.disconnect}}
            @text={{t "account.meta_marketing_api.business_account_tab.remove_button"}}
            @variant="mute"
            class="qa--mmaBusinessTab__removeBtn"
          />
        </section.wrapper>
      </Section>
    {{else}}
      <div class="tAC--mmaBusinessTab__empty">
        <span class="tAC--mmaBusinessTab__emptyText qa--mmaBusinessTab__emptyText">
          {{t "account.meta_marketing_api.business_account_tab.empty.description"}}
        </span>
        <Shared::Ui::Button
          @promise={{this.connect}}
          @size="small"
          @text={{t "account.meta_marketing_api.business_account_tab.empty.connect_button"}}
          @variant="outline"
          class="tAC--mmaBusinessTab__connectBtn qa--mmaBusinessTab__connectBtn"
        />
      </div>
    {{/if}}
  </section>
  */
  {
    "id": "+zJmxcwq",
    "block": "[[[10,\"section\"],[14,0,\"tAC--mmaBusinessTab qa--mmaBusinessTab\"],[12],[1,\"\\n\"],[41,[30,0,[\"metaAdUser\"]],[[[1,\"    \"],[10,0],[14,0,\"tAC--mmaBusinessTab__headerRow\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaBusinessTab__accountInfo\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaBusinessTab__accountName qa--mmaBusinessTab__accountName\"],[12],[1,\"\\n          \"],[1,[30,0,[\"metaAdUser\",\"metaAccountName\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"shouldShowExpiresIn\"]],[[[1,\"          \"],[10,1],[15,0,[29,[\"tAC--mmaBusinessTab__expiresIn \",[30,0,[\"expiresInClass\"]],\" u--text--xs qa--mmaBusinessTab__expiresIn\"]]],[14,\"data-test-id\",\"mma-business-tab-expires-in\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.social_accounts.expires_in.label\"],null]],[1,\"\\n            \"],[1,[28,[35,1],[\"account.social_accounts.expires_in.value\"],[[\"days\"],[[30,0,[\"expiresInDays\"]]]]]],[1,\"\\n            \"],[8,[39,2],[[24,\"data-test-id\",\"mma-business-tab-expires-in-tooltip\"]],[[\"@icon\",\"@side\",\"@tooltip\"],[\"info\",\"top\",[28,[37,1],[\"account.meta_marketing_api.business_account_tab.expires_in.tooltip\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"tAC--mmaBusinessTab__expiresIn u--text--danger u--text--xs qa--mmaBusinessTab__expired\"],[14,\"data-test-id\",\"mma-business-tab-expired\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.expires_in.expired\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaBusinessTab__actions\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,0,\"tAC--mmaBusinessTab__btn qa--mmaBusinessTab__editBtn\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,0,[\"manageAdAccounts\"]],\"small\",\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,4],[\"edit\"],[[\"class\"],[\"o--icon--xs tAC--mmaBusinessTab__btnIcon\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.edit_button\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[39,3],[[24,0,\"tAC--mmaBusinessTab__btn qa--mmaBusinessTab__refreshBtn\"]],[[\"@promise\",\"@size\",\"@variant\"],[[30,0,[\"refresh\"]],\"small\",\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,4],[\"refresh\"],[[\"class\"],[\"o--icon--xs tAC--mmaBusinessTab__btnIcon\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.refresh_button\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[11,\"table\"],[24,0,\"tAC--mmaBusinessTab__table qa--mmaBusinessTab__table\"],[4,[38,5],[[30,0,[\"onTableInserted\"]]],null],[12],[1,\"\\n      \"],[10,\"thead\"],[12],[1,\"\\n        \"],[10,\"tr\"],[12],[1,\"\\n          \"],[10,\"th\"],[14,0,\"tAC--mmaBusinessTab__th tAC--mmaBusinessTab__th--name\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"tAC--mmaBusinessTab__thLabel\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.table.ad_account\"],null]],[1,\"\\n              \"],[8,[39,2],[[24,\"data-test-id\",\"mma-business-tab-ad-account-tooltip\"]],[[\"@icon\",\"@side\",\"@tooltip\"],[\"info\",\"top\",[28,[37,1],[\"account.meta_marketing_api.business_account_tab.table.ad_account_tooltip\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"th\"],[14,0,\"tAC--mmaBusinessTab__th\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.table.access_groups\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"adAccounts\"]]],null]],null],null,[[[1,\"          \"],[10,\"tr\"],[14,0,\"tAC--mmaBusinessTab__tr qa--mmaBusinessTab__row\"],[15,\"data-ad-account-id\",[30,1,[\"id\"]]],[12],[1,\"\\n            \"],[10,\"td\"],[14,0,\"tAC--mmaBusinessTab__td tAC--mmaBusinessTab__td--name qa--mmaBusinessTab__name\"],[12],[1,\"\\n              \"],[1,[30,1,[\"name\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"tAC--mmaBusinessTab__td tAC--mmaBusinessTab__td--groups\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"tAC--mmaBusinessTab__badges\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[28,[30,0,[\"groupsFor\"]],[[30,1]],null]],null]],null],null,[[[1,\"                  \"],[10,1],[14,0,\"tAC--mmaBusinessTab__badge qa--mmaBusinessTab__badge\"],[12],[1,[30,2,[\"name\"]]],[13],[1,\"\\n\"]],[2]],null],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,8],[[24,0,\"tAC--mmaBusinessTab__removeSection qa--mmaBusinessTab__removeSection\"]],[[\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.meta_marketing_api.business_account_tab.remove_section.title\"],null],\"u--text--danger\"]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,3,[\"wrapper\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,3,[\"details\"]],null,[[\"@title\",\"@titleStyles\"],[[28,[37,1],[\"account.meta_marketing_api.business_account_tab.remove_section.description\"],null],\"u--text--danger u--text--md\"]],null],[1,\"\\n        \"],[8,[39,3],[[24,0,\"qa--mmaBusinessTab__removeBtn\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"metaMarketingApiAuth\",\"disconnect\"]],[28,[37,1],[\"account.meta_marketing_api.business_account_tab.remove_button\"],null],\"mute\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[3]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"tAC--mmaBusinessTab__empty\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"tAC--mmaBusinessTab__emptyText qa--mmaBusinessTab__emptyText\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.meta_marketing_api.business_account_tab.empty.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,3],[[24,0,\"tAC--mmaBusinessTab__connectBtn qa--mmaBusinessTab__connectBtn\"]],[[\"@promise\",\"@size\",\"@text\",\"@variant\"],[[30,0,[\"connect\"]],\"small\",[28,[37,1],[\"account.meta_marketing_api.business_account_tab.empty.connect_button\"],null],\"outline\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"adAccount\",\"group\",\"section\"],false,[\"if\",\"t\",\"shared/ui/icon-tooltip\",\"shared/ui/button\",\"svg-jar\",\"did-insert\",\"each\",\"-track-array\",\"section\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/business-account-tab/index.hbs",
    "isStrictMode": false
  });
  // Matches the social-profile "expiring soon" window (SocialProfile#expiringWithinDays default).
  const EXPIRING_SOON_DAYS = 7;
  const LOCATION = 'meta tab';
  const PAGE = 'meta account';

  /**
   * Account-level "Meta Business Account" settings tab. Renders the empty state
   * (Connect prompt) when no Meta business account is connected, or the connected
   * state (account name + Refresh/Edit/Remove + a read-only Ad Account → Access
   * Group(s) table) otherwise. Edit reuses the post-OAuth assignments modal.
   */
  let MetaAdAccountsCardBusinessAccountTabComponent = _exports.default = (_class = class MetaAdAccountsCardBusinessAccountTabComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "metaMarketingApiAuth", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "store", _descriptor4, this);
      // Wrappers exist because Shared::Ui::Button performs @promise tasks with no arguments.
      _defineProperty(this, "connect", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track(_segmentEvents.SegmentEventTypes.ClickedConnectMetaBusinessAccount, {
            location: LOCATION
          });
          yield this.metaMarketingApiAuth.connect.perform();
        }
      }), null, "connect", null));
      _defineProperty(this, "refresh", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track(_segmentEvents.SegmentEventTypes.ClickedRefreshMetaBusinessAccount, {
            location: LOCATION
          });
          yield this.metaMarketingApiAuth.refresh.perform();
        }
      }), null, "refresh", null));
      // Resolve each ad account's assigned groups for the badge column. Reads the
      // `groups` hasMany (backend serializes `group_ids`, parsed against Group
      // records in the store).
      _defineProperty(this, "groupsFor", adAccount => (0, _toArray.default)(adAccount.groups));
      _defineProperty(this, "loadAdAccounts", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.store.findAll('meta-ad-account', {
            reload: true
          });
        }
      }), null, "loadAdAccounts", null));
      this.segment.track(_segmentEvents.SegmentEventTypes.ViewedPage, {
        page: PAGE
      });
    }
    manageAdAccounts() {
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedManageAdAccounts, {
        location: LOCATION
      });
      this.metaMarketingApiAuth.openAssignmentsModal();
    }
    get metaAdUser() {
      return this.auth.currentUserModel?.metaAdUser;
    }
    get expiresInDays() {
      return (0, _expiresInDays.default)(this.metaAdUser?.tokenExpiresTime);
    }
    get shouldShowExpiresIn() {
      return typeof this.expiresInDays === 'number';
    }
    get isExpiringSoon() {
      return typeof this.expiresInDays === 'number' && this.expiresInDays <= EXPIRING_SOON_DAYS;
    }
    get expiresInClass() {
      return this.isExpiringSoon ? 'u--text--warning' : 'u--text--light';
    }

    // All of the connected user's ad accounts, soft-deleted rows excluded. Sourced
    // from the store (peekAll) so a reload — on tab insert, or after the assignments
    // modal saves — flows through reactively.
    get adAccounts() {
      return (0, _toArray.default)(this.store.peekAll('meta-ad-account')).filter(account => !account.disconnectedTime);
    }
    onTableInserted() {
      void this.loadAdAccounts.perform();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "metaMarketingApiAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "manageAdAccounts", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "manageAdAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTableInserted", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTableInserted"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MetaAdAccountsCardBusinessAccountTabComponent);
});